import Notification, { NotificationSeverity } from '@/components/notifications/Notification';
import { ShippingSearchInput, AmendmentForm, EmptyShippingSearch } from '../../components';
import ShippingDetails from '@/pages/Business/pages/Shippings/components/ShippingDetails';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { amendmentsBreadcrumbs } from '../../config/breadcrumbs';
import { History as HistoryIcon } from '@mui/icons-material';
import { NavigateLinks, GlobalButton, Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { useApplyAmendmentController } from '../../hooks';
import { useNavigate } from 'react-router-dom';
import { LoaderBackdrop } from '@/components';
import { useMemo } from 'react';

const ApplyAmendment = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(() => amendmentsBreadcrumbs(navigate), [navigate]);

  const {
    shipping,
    isShippingLoading,
    searchKey,
    draftSearchInput,
    searchMode,
    setSearchMode,
    handleSearch,
    amendmentOptions,
    isAmendmentsLoading,
    handleApply,
    isApplying,
    successMessage,
    errorMessage,
    setSuccessMessage,
    setErrorMessage,
  } = useApplyAmendmentController();

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <div className='flex flex-col gap-4'>
        <NavigateLinks actualPage='Enmiendas' breadcrumbs={breadcrumbs} />
        <Authorize permission={BUSINESS_ROLE_GROUPS.adminOrSupervisor}>
          <div className='flex justify-end'>
            <GlobalButton
              variant={GlobalButtonVariant.primaryButton}
              action={() => navigate('/business/amendments/history')}
            >
              <HistoryIcon />
              Historial de enmiendas
            </GlobalButton>
          </div>
        </Authorize>
      </div>

      <div className='w-full flex flex-col gap-6'>
        <ShippingSearchInput
          key={searchKey}
          onSearch={handleSearch}
          isLoading={isShippingLoading}
          defaultValue={searchKey === 0 ? draftSearchInput ?? '' : ''}
          mode={searchMode}
          onModeChange={setSearchMode}
        />

        {!shipping && <EmptyShippingSearch />}

        {shipping && (
          <>
            <div className='bg-white rounded-lg shadow-md p-6 border border-gray-200'>
              <ShippingDetails shipping={shipping} />
            </div>

            <AmendmentForm
              key={String(shipping.number)}
              amendmentOptions={amendmentOptions}
              isAmendmentsLoading={isAmendmentsLoading}
              onApply={handleApply}
              isApplying={isApplying}
              currentStatusName={shipping.status?.commercialName ?? ''}
            />
          </>
        )}
      </div>

      {isShippingLoading && <LoaderBackdrop />}

      <Notification
        open={!!successMessage}
        message={successMessage ?? ''}
        severity={NotificationSeverity.success}
        duration={5000}
        onClose={() => setSuccessMessage(null)}
      />
      <Notification
        open={!!errorMessage}
        message={errorMessage ?? ''}
        severity={NotificationSeverity.error}
        duration={5000}
        onClose={() => setErrorMessage(null)}
      />
    </section>
  );
};

export default ApplyAmendment;
